import { registerMockAPI } from '~/mocks/mockApis';

import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import type {
  TypeApiResponse,
  TypePostRequestCancelParams,
  TypePostRequestCancelResponse,
} from '~/types/receive.types';

type CancelParams = {
  ownerCode: string;
  params: TypePostRequestCancelParams;
};

/**
 * [입고요청관리] 입고요청 취소 API
 */
const fetchPostRequestCancel = async ({ ownerCode, params }: CancelParams) => {
  const endpoint = '/api-inbound/v1/3pl/receiving';
  const { data } = await axiosInstance.post<TypeApiResponse<TypePostRequestCancelResponse>>(
    `${endpoint}/${ownerCode}/request/cancel`,
    params
  );
  return data.data;
};

/**
 * [입고요청관리] 입고요청 취소 Mutation Hook
 */
export const usePostRequestCancelMutation = () => {
  return useMutation({
    mutationFn: fetchPostRequestCancel,
  });
};

const normalResponse: TypeApiResponse<TypePostRequestCancelResponse> = {
  data: {
    ids: [1001, 1002],
  },
};

registerMockAPI<TypeApiResponse<TypePostRequestCancelResponse>>({
  method: 'post',
  endpoint: '/api-inbound/v1/3pl/receiving/:ownerCode/request/cancel',
  label: '입고/입고요청/요청취소',
  scenarios: [
    { name: '정상 응답', response: normalResponse },
    {
      name: '서버 오류',
      response: { error: { message: '입고 요청 취소 중 오류가 발생했습니다.' } },
      status: 500,
    },
  ],
});
